import Vue from 'vue'
import VueRouter from 'vue-router'
import { trackPath, transformGamePath } from '@/utils/utils'
import { CPREFIX, ROUTER_ALL } from '@/utils/routerRrefix'
import { reRouteFix, ROUTE_FIX, routeContains } from '@/config/routePrefix'
import { PQ } from '@/utils/priorityQueue'

const SPREAD_GAME = transformGamePath()

const Home = () => import('@/pages/Home/index').then((c) => c.default || c)
const PayResult = () => import('@/pages/Pay/index').then((c) => c.default || c)
const OrderQuery = () =>
  import('@/pages/Order/query').then((c) => c.default || c)
const OrderDetail = () =>
  import('@/pages/Order/detail').then((c) => c.default || c)
const DocPrivacy = () =>
  import('@/pages/Doc/privacy').then((c) => c.default || c)
const DocTerms = () => import('@/pages/Doc/terms').then((c) => c.default || c)
const DocNotice = () => import('@/pages/Doc/notice').then((c) => c.default || c)
const OrderIndex = () =>
  import('@/pages/Order/index').then((c) => c.default || c)
const MessageIndex = () =>
  import('@/pages/Message/index').then((c) => c.default || c)
const AboutIndex = () =>
  import('@/pages/About/index').then((c) => c.default || c)
const NewCouponList = () =>
  import('@/pages/newCouponList').then((c) => c.default || c)
const HistoryCoupon = () =>
  import('@/pages/HistoryCoupon').then((c) => c.default || c)
const NativeFeedback = () =>
  import('@/pages/Native/feedback').then((c) => c.default || c)
const NativeFeedbackEdit = () =>
  import('@/pages/Native/feedbackEdit').then((c) => c.default || c)
const FacebookIndex = () =>
  import('@/pages/Facebook/index').then((c) => c.default || c)
const AccountIndex = () =>
  import('@/pages/Account/index').then((c) => c.default || c)
const ContactIndex = () =>
  import('@/pages/Contact/index').then((c) => c.default || c)
const NativeFeedbackRecord = () =>
  import('@/pages/Native/feedbackRecord').then((c) => c.default || c)
const NativeMessageBoard = () =>
  import('@/pages/Native/messageBoard').then((c) => c.default || c)
const OrderSearch = () =>
  import('@/pages/Order/search').then((c) => c.default || c)
const BingIndex = () => import('@/pages/Bing/index').then((c) => c.default || c)
const LuckyDrawIndex = () =>
  import('@/pages/Activity/LuckyDraw/index').then((c) => c.default || c)
const PrizeRecord = () =>
  import('@/pages/Activity/LuckyDraw/PrizeRecord/index').then(
    (c) => c.default || c
  )
const FeedbackAnswer = () =>
  import('@/pages/Native/feedbackAnswer').then((c) => c.default || c)
const DetailIndex = () =>
  import('@/pages/Detail/index').then((c) => c.default || c)
const WalletIndex = () =>
  import('@/pages/Wallet/index').then((c) => c.default || c)
const RechargeResultIndex = () =>
  import('@/pages/Wallet/RechargeResult').then((c) => c.default || c)
const ExpensesRecordIndex = () =>
  import('@/pages/ExpensesRecord').then((c) => c.default || c)
const EmailIndex = () =>
  import('@/pages/Email/index').then((c) => c.default || c)
const PasswordBindIndex = () =>
  import('@/pages/PasswordBind/index').then((c) => c.default || c)
const PasswordEditIndex = () =>
  import('@/pages/PasswordEdit/index').then((c) => c.default || c)
const AccountAppealIndex = () =>
  import('@/pages/AccountAppeal/index').then((c) => c.default || c)
const MembersRule = () =>
  import('@/pages/Members/rule').then((c) => c.default || c)

const MembersPrivilege = () =>
  import('@/pages/Members/privilege').then((c) => c.default || c)
const MembersReward = () =>
  import('@/pages/Members/reward').then((c) => c.default || c)

const LoginCodePage = () =>
  import('@/pages/Login/code').then((c) => c.default || c)
const CookiePolicy = () =>
  import('@/pages/CookiePolicy').then((c) => c.default || c)

const FissionHome = () =>
  import('@/pages/Activity/Fission/Home/index').then((c) => c.default || c)
const FissionExchange = () =>
  import('@/pages/Activity/Fission/Exchange/index').then((c) => c.default || c)
const FissionRules = () =>
  import('@/pages/Activity/Fission/Rules/index').then((c) => c.default || c)
const FissionRecord = () =>
  import('@/pages/Activity/Fission/Record/index').then((c) => c.default || c)

const Shorturl = () =>
  import('@/pages/Shorturl/index').then((c) => c.default || c)

const AppSideBar = () =>
  import('@/pages/AppSidebar/index').then((c) => c.default || c)

const RankingHome = () =>
  import('@/pages/Activity/Ranking/Home/index').then((c) => c.default || c)
const RankingRules = () =>
  import('@/pages/Activity/Ranking/Rules/index').then((c) => c.default || c)

const GetLuckyHome = () =>
  import('@/pages/Activity/GetLucky/Home/index').then((c) => c.default || c)
const GetLuckyResult = () =>
  import('@/pages/Activity/GetLucky/Result/index').then((c) => c.default || c)
const GetLuckyRule = () =>
  import('@/pages/Activity/GetLucky/Rule/index').then((c) => c.default || c)
const GetLuckyWinningRecord = () =>
  import('@/pages/Activity/GetLucky/Record/winning').then((c) => c.default || c)

const GetLuckyExchangeRecord = () =>
  import('@/pages/Activity/GetLucky/Record/exchange').then(
    (c) => c.default || c
  )

const KCardExchange = () => import('@/pages/Kcard').then((c) => c.default || c)

const Compensation = () =>
  import('@/pages/Compensation').then((c) => c.default || c)

const EUnsub = () => import('@/pages/EUnsub').then((c) => c.default || c)
// const SSRdetail = () => import('@/pages/SSRdetail').then((c) => c.default || c)

const bindPhone = () => import('@/pages/bindPhone').then((c) => c.default || c)
const bindPhoneSuccess = () =>
  import('@/pages/bindSuccess').then((c) => c.default || c)

const modifyPhone = () =>
  import('@/pages/modifyPhone').then((c) => c.default || c)

Vue.use(VueRouter)

export const safePathMaps = [...ROUTER_ALL, ...SPREAD_GAME, ...ROUTE_FIX]

const AbbreviationKeys = Object.keys(CPREFIX)

const prefix = `${reRouteFix()}?`
const ROUTER_BASE = (() => {
  const rawBase = process.env.VUE_APP_ROUTER_BASE || '/'
  const base = rawBase.startsWith('/') ? rawBase : `/${rawBase}`
  return base.endsWith('/') ? base : `${base}/`
})()

// 解决多层path的问题
const fixManyPath = (pathName, routes, safePathMaps) => {
  const isFix = pathName.lastIndexOf('/')
  let result = false
  let splitPath = []

  if (isFix > 0) {
    const routesArr = routes.map((item) => item.path)

    routesArr.forEach((item) => {
      if (item !== '/') {
        let data = item.split('?')[1] ? item.split('?')[1] : ''
        splitPath.push(data)
      }
    })
    splitPath = splitPath.filter((item) => !!item)

    const filterSafePathMaps = safePathMaps.filter((item) => !!item)

    result = filterSafePathMaps.some((item) =>
      splitPath.find((_item) => item == _item)
    )
  }
  return result
}

// 只保留当前页面的track_ga数据
const clearCookieCollect = () => {
  if (process.server) return
  window.__trackQueue = []
}

export function createRouter() {
  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: reRouteFix(),
      name: 'RouteFix',
      component: Home,
    },
    {
      path: `${prefix}/home`,
      name: 'homeIndex',
      component: Home,
    },
    {
      path: `${prefix}/email`,
      name: 'email',
      component: EmailIndex,
    },
    {
      path: `${prefix}/password-bind`,
      name: 'password-bind',
      component: PasswordBindIndex,
    },
    {
      path: `${prefix}/password-edit`,
      name: 'password-edit',
      component: PasswordEditIndex,
    },
    {
      path: `${prefix}/account-appeal`,
      name: 'account-appeal',
      component: AccountAppealIndex,
    },
    {
      path: `${prefix}/pay-result`,
      name: 'payResult',
      component: PayResult,
    },
    {
      path: `${prefix}/order-query`,
      name: 'orderQuery',
      component: OrderQuery,
    },
    {
      path: `${prefix}/order-detail`,
      name: 'orderDetail',
      component: OrderDetail,
    },
    {
      path: `${prefix}/privacy`,
      name: 'Privacy',
      component: DocPrivacy,
    },
    {
      path: `${prefix}/terms`,
      name: 'Terms',
      component: DocTerms,
    },
    {
      path: `${prefix}/notice`,
      name: 'Notice',
      component: DocNotice,
    },
    {
      path: `${prefix}/order`,
      name: 'Order',
      component: OrderIndex,
    },
    {
      path: `${prefix}/message`,
      name: 'Message',
      component: MessageIndex,
    },
    {
      path: '/about',
      name: 'About',
      alias: '/:country?/about',
      component: AboutIndex,
    },
    {
      path: `${prefix}/coupon`,
      name: 'Coupon',
      component: NewCouponList,
    },
    {
      path: `${prefix}/history-coupon`,
      name: 'historyCoupon',
      component: HistoryCoupon,
    },
    {
      path: `${prefix}/feedback`,
      name: 'Feedback',
      component: NativeFeedback,
    },
    {
      path: `${prefix}/feedback-edit`,
      name: 'FeedbackEdit',
      component: NativeFeedbackEdit,
    },
    {
      path: `${prefix}/facebook`,
      name: 'facebook',
      component: FacebookIndex,
    },
    {
      path: `${prefix}/account`,
      name: 'account',
      component: AccountIndex,
    },
    {
      path: `${prefix}/contact`,
      name: 'contact',
      component: ContactIndex,
    },
    {
      path: `${prefix}/feedback-record`,
      name: 'feedback-record',
      component: NativeFeedbackRecord,
    },
    {
      path: `${prefix}/messageBoard`,
      name: 'messageBoard',
      component: NativeMessageBoard,
    },
    {
      path: `${prefix}/search-order`,
      name: 'searchOrder',
      component: OrderSearch,
    },
    {
      path: `${prefix}/bing`,
      name: 'Bing',
      component: BingIndex,
    },
    {
      path: `${prefix}/luckyDraw`,
      name: 'luckyDraw',
      component: LuckyDrawIndex,
    },
    {
      path: `${prefix}/prize-record`,
      name: 'prizeRecord',
      component: PrizeRecord,
    },
    {
      path: `${prefix}/feedback-answer`,
      name: 'feedbackAnswer',
      component: FeedbackAnswer,
    },
    {
      path: `${prefix}/myWallet`,
      name: 'myWallet',
      component: WalletIndex,
    },
    {
      path: `${prefix}/rechargeResult`,
      name: 'rechargeResult',
      component: RechargeResultIndex,
    },
    {
      path: `${prefix}/expensesRecord`,
      name: 'expensesRecord',
      component: ExpensesRecordIndex,
    },
    {
      path: `${prefix}/membersRule`,
      name: 'membersRule',
      component: MembersRule,
    },
    {
      path: `${prefix}/membersPrivilege`,
      name: 'membersPrivilege',
      component: MembersPrivilege,
    },
    {
      path: `${prefix}/membersReward`,
      name: 'membersReward',
      component: MembersReward,
    },
    {
      name: 'loginCode',
      path: `${prefix}/loginCode`,
      component: LoginCodePage,
    },
    {
      path: `${prefix}/cookiePolicy`,
      name: 'cookiePolicy',
      component: CookiePolicy,
    },
    {
      path: `${prefix}/fission`,
      name: 'FissionHome',
      component: FissionHome,
    },
    {
      path: `${prefix}/fission-exchange`,
      name: 'FissionExchange',
      component: FissionExchange,
    },
    {
      path: `${prefix}/fission-rules`,
      name: 'FissionRules',
      component: FissionRules,
    },
    {
      path: `${prefix}/fission-record`,
      name: 'FissionRecord',
      component: FissionRecord,
    },
    {
      path: `${prefix}/appSidebar`,
      name: 'AppSideBar',
      component: AppSideBar,
    },
    {
      path: `${prefix}/share/:hashcode`,
      name: 'Shorturl',
      component: Shorturl,
    },
    {
      path: `${prefix}/ranking`,
      name: 'RankingHome',
      component: RankingHome,
    },
    {
      path: `${prefix}/ranking-rules`,
      name: 'RankingRules',
      component: RankingRules,
    },
    {
      path: `${prefix}/getlucky`,
      name: 'GetLuckyHome',
      component: GetLuckyHome,
    },
    {
      path: `${prefix}/getlucky-result`,
      name: 'GetLuckyResult',
      component: GetLuckyResult,
    },
    {
      path: `${prefix}/getlucky-rule`,
      name: 'GetLuckyRule',
      component: GetLuckyRule,
    },
    {
      path: `${prefix}/getlucky-record-winning`,
      name: 'GetLuckyWinningRecord',
      component: GetLuckyWinningRecord,
    },
    {
      path: `${prefix}/getlucky-record-exchange`,
      name: 'GetLuckyExchangeRecord',
      component: GetLuckyExchangeRecord,
    },
    {
      path: `${prefix}/kcard-redemption`,
      name: 'kCardExchange',
      component: KCardExchange,
    },
    {
      path: `${prefix}/compen-query`,
      name: 'compensation-query',
      component: Compensation,
    },
    {
      path: `${prefix}/eUnsub`,
      name: 'EUnsub',
      component: EUnsub,
    },
    {
      path: `${prefix}/bind-mobile-phone`,
      name: 'binPhone',
      component: bindPhone,
    },
    {
      path: `${prefix}/bind-successful`,
      name: 'bindSuccessful',
      component: bindPhoneSuccess,
    },
    {
      path: `${prefix}/modify-phone`,
      name: 'modifyPhone',
      component: modifyPhone,
    },
    // { path: `${prefix}/hago`, name: 'hago', component: SSRdetail },
    {
      path: `${prefix}/:gameName`,
      name: 'Detail2',
      component: DetailIndex,
    },

    { path: '*', redirect: '/' },
  ]

  const router = new VueRouter({
    base: ROUTER_BASE,
    mode: 'history',
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 }
    },
  })

  router.beforeEach((to, from, next) => {
    PQ.clear()
    let fromPath = from.path
    let toPath = to.path
    trackPath(fromPath, toPath)
    clearCookieCollect()
    const { path } = to || {}

    if (CPREFIX[path]) {
      next(CPREFIX[path])
      return
    }

    if (to.name === 'RouteFix') {
      next()
      return
    }
    const _path = path.slice(1).split('/') ? path.slice(1).split('/')[0] : ''

    // ! 兼容 新增的多层域名
    const pathName = path.slice(3)
    const isManyPath = fixManyPath(pathName, routes, safePathMaps)
    if (routeContains(path) && _path && ROUTE_FIX.includes(`/${_path}`)) {
      const pathName = path.slice(3)
      const pathNameFix = path.slice(0, 3)

      // todo 兼容简写方式
      if (AbbreviationKeys.includes(pathName)) {
        const result = AbbreviationKeys.find((item) => item === pathName)
        const redirectPath = CPREFIX[result]
        next(`${pathNameFix}${redirectPath}`)
        return
      }
      if (isManyPath) {
        next()
        return
      }

      if (!safePathMaps.includes(pathName)) {
        next(pathNameFix)
        return
      }
      next()
      return
    }
    // 兼容动态路由
    const pathSecondIndex = path.indexOf('/', 2)
    const pathPreview =
      pathSecondIndex > 1 ? path.slice(0, pathSecondIndex) : path

    if (isManyPath) {
      next()
      return
    }
    if (!safePathMaps.includes(pathPreview)) {
      next('/')
      return
    }
    next()
  })

  return router
}
